module.exports = __webpack_public_path__ + "assets/ic_tree26.026b5720.svg";